import {
    all,
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';
import { closeWorkspaceOverlay } from 'common/store/workspaces/actions';
import { STIMULUS_FEATURE_ID } from 'common/util/utils';
import apiService from '../../services/apiService';
import { AddQuestionsActionsName, FetchSelectedQuestionDetails } from './types';
import { setSelectedQuestionDetails } from './action';
import sectionLayoutService from '../../features/structureEditor/services/SectionLayoutService';
import { SectionLayout } from '../context/types';

function* fetchQuestionDetailsSaga(action: FetchSelectedQuestionDetails) {
    if (!action.stimulusContentRevisionId || isNaN(action.stimulusContentRevisionId)) return;
    try {
        const response = yield call(apiService.fetchQuestionData, action.stimulusContentRevisionId);
        if (response?.liveRevision) {
            const {
                textContent, objectType, title, id,
            } = response.liveRevision;
            yield put(setSelectedQuestionDetails(textContent, objectType, title, id, action.stimulusContentRevisionId));
            yield put(closeWorkspaceOverlay());
            yield call(waitForOverlayClose);
            yield call(sectionLayoutService.openStimulusAndLayoutModal,
                STIMULUS_FEATURE_ID,
                undefined, {} as SectionLayout,
                true);
        }
    } catch (error) {
        console.error('Error fetching question text content', error);
    }
}

function* watchFetchQuestionDetails() {
    yield takeLatest(AddQuestionsActionsName.FETCH_QUESTION_DETAILS, fetchQuestionDetailsSaga);
}

const waitForOverlayClose = () => {
    return new Promise((resolve) => {
        setTimeout(resolve, 10);
    });
};

function* rootSelectedQuestionDetailsSaga() {
    yield all([
        watchFetchQuestionDetails(),
    ]);
}

export default rootSelectedQuestionDetailsSaga;
